import { graphql } from "relay-runtime"

export const chPatientEpisodesOfCareQuery = graphql`
  query chPatientEpisodesOfCareQuery(
    $patientId: ID!
    $appointmentId: ID
    $shouldCreateDraftProgressNote: Boolean!
    $kind: ProgressNoteKind!
    $language: Language!
  ) {
    patientEpisodesOfCare: ch_patientEpisodesOfCare(
      patientId: $patientId
      appointmentId: $appointmentId
      shouldCreateDraftProgressNote: $shouldCreateDraftProgressNote
      kind: $kind
      language: $language
      first: null
    ) @connection(key: "RootEpisodesOfCareConnection_patientEpisodesOfCare", filters: ["patientId"]) {
      edges {
        node {
          ...chEpisodeOfCareFragment @relay(mask: false)
          ...chEpisodeOfCareFragment
        }
      }
    }
  }
`
